/* Bird Street Bistro — Bundle Builder
   Vanilla JS controller. Re-instantiates per section to support multiple instances. */
(function () {
  'use strict';

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function priceCents(card) {
    // Shopify's `product.price` outputs an integer in the shop currency's smallest unit
    // (cents for USD, etc.) — locale-safe, no decimal/thousands ambiguity.
    return parseInt(card.dataset.productPriceCents || '0', 10) || 0;
  }

  function init(section) {
    // Idempotency guard: don't re-bind handlers if this section was already initialized.
    if (section.dataset.bbInitialized === '1') return;
    section.dataset.bbInitialized = '1';

    var sizeButtons = section.querySelectorAll('[data-size]');
    var defaultSize = parseInt(section.dataset.defaultSize || '8', 10);
    var cards = section.querySelectorAll('[data-product-card]');
    var cartItemsEl = section.querySelector('[data-cart-items]');
    var cartPillEls = section.querySelectorAll('[data-cart-pill]');
    var sizeLabelEls = section.querySelectorAll('[data-bundle-size]');
    var selectedCountEls = section.querySelectorAll('[data-selected-count]');
    var subtotalEls = section.querySelectorAll('[data-subtotal]');
    var retailEl = section.querySelector('[data-retail]');
    var savingsEl = section.querySelector('[data-savings-display]');
    var saveRow = section.querySelector('[data-save-row]');
    var progressFill = section.querySelector('[data-progress-fill]');
    var ctaButtons = section.querySelectorAll('[data-add-to-cart]');
    var ctaLabels = section.querySelectorAll('[data-cta-label]');
    var tierEls = section.querySelectorAll('[data-tier-size]');
    var categoryTabs = section.querySelectorAll('[data-category-tab]');
    var categories = section.querySelectorAll('[data-category]');

    var state = {
      bundleSize: defaultSize,
      tiers: {}, // { 4: {price, savings}, ... }
      selections: {} // { variantId: { qty, card } }
    };

    // Build tier price map from size buttons
    sizeButtons.forEach(function (btn) {
      state.tiers[btn.dataset.size] = {
        price: parseFloat(btn.dataset.price || '0'),
        savings: parseFloat(btn.dataset.savings || '0')
      };
    });

    // ---- Category tabs ----
    function activateCategory(handle) {
      categoryTabs.forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.categoryTab === handle);
      });
      var target = section.querySelector('[data-category="' + handle + '"]');
      if (target) {
        var offset = 100;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }
    if (categoryTabs.length > 0) {
      // Mark first tab active visually
      categoryTabs[0].classList.add('is-active');
      // Click = scroll to section
      categoryTabs.forEach(function (tab) {
        tab.addEventListener('click', function () { activateCategory(tab.dataset.categoryTab); });
      });
    }

    // ---- Size selection ----
    function setSize(size) {
      state.bundleSize = size;
      sizeButtons.forEach(function (b) {
        b.setAttribute('aria-checked', b.dataset.size === String(size) ? 'true' : 'false');
      });
      sizeLabelEls.forEach(function (el) { el.textContent = String(size); });
      cartPillEls.forEach(function (el) { el.textContent = size + '-PACK'; });

      // Trim selections if exceeding new size
      var total = totalSelected();
      if (total > size) {
        // Reduce from the most-recently-added items
        var ids = Object.keys(state.selections);
        for (var i = ids.length - 1; i >= 0 && total > size; i--) {
          var id = ids[i];
          while (state.selections[id] && state.selections[id].qty > 0 && total > size) {
            state.selections[id].qty -= 1;
            if (state.selections[id].qty === 0) delete state.selections[id];
            total -= 1;
          }
        }
      }
      render();
    }
    sizeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () { setSize(parseInt(btn.dataset.size, 10)); });
    });
    setSize(defaultSize);

    // ---- Card actions ----
    cards.forEach(function (card) {
      var addBtn = card.querySelector('[data-action="add"]');
      var stepper = card.querySelector('[data-stepper]');
      var incBtn = card.querySelector('[data-action="increment"]');
      var decBtn = card.querySelector('[data-action="decrement"]');
      var variantId = card.dataset.variantId;

      addBtn.addEventListener('click', function () { addOne(variantId, card); });
      incBtn.addEventListener('click', function () { addOne(variantId, card); });
      decBtn.addEventListener('click', function () { removeOne(variantId); });
    });

    function totalSelected() {
      return Object.keys(state.selections).reduce(function (sum, id) {
        return sum + state.selections[id].qty;
      }, 0);
    }

    function addOne(variantId, card) {
      if (totalSelected() >= state.bundleSize) return;
      if (!state.selections[variantId]) {
        state.selections[variantId] = { qty: 0, card: card };
      }
      state.selections[variantId].qty += 1;
      render();
    }

    function removeOne(variantId) {
      if (!state.selections[variantId]) return;
      state.selections[variantId].qty -= 1;
      if (state.selections[variantId].qty <= 0) delete state.selections[variantId];
      render();
    }

    // ---- Render ----
    function render() {
      var size = state.bundleSize;
      var total = totalSelected();
      var isFull = total >= size;
      var tierInfo = state.tiers[String(size)] || { price: 0, savings: 0 };

      // Counts
      selectedCountEls.forEach(function (el) { el.textContent = String(total); });

      // Progress
      if (progressFill) progressFill.style.width = Math.min(100, (total / size) * 100) + '%';

      // Tier dividers / locked styling
      tierEls.forEach(function (t) {
        var s = parseInt(t.dataset.tierSize, 10);
        t.classList.toggle('is-active-or-below', size >= s);
        t.classList.toggle('is-current', size === s);
      });

      // Slots
      // Build a flat list of filled slots from selections
      var filled = [];
      Object.keys(state.selections).forEach(function (id) {
        var entry = state.selections[id];
        for (var i = 0; i < entry.qty; i++) filled.push(entry.card);
      });

      var TIERS = [
        { size: 4, from: 0, to: 4 },
        { size: 8, from: 4, to: 8 },
        { size: 12, from: 8, to: 12 }
      ];
      TIERS.forEach(function (tier) {
        var slotsContainer = section.querySelector('[data-tier-slots="' + tier.size + '"]');
        if (!slotsContainer) return;
        slotsContainer.innerHTML = '';
        for (var i = tier.from; i < tier.to; i++) {
          var slot = document.createElement('div');
          slot.className = 'bb__slot';
          var card = filled[i];
          if (card) {
            slot.classList.add('is-filled');
            var img = card.dataset.productImage;
            if (img) slot.style.backgroundImage = 'url(' + img + ')';
            var label = document.createElement('span');
            label.className = 'bb__slot-label';
            label.textContent = (card.dataset.productTitle || '').split(' ')[0];
            slot.appendChild(label);
            var overlay = document.createElement('span');
            overlay.className = 'bb__slot-overlay';
            overlay.textContent = '\u2715';
            slot.appendChild(overlay);
            (function (c) {
              slot.addEventListener('click', function () { removeOne(c.dataset.variantId); });
            })(card);
          } else {
            if (i >= size) slot.classList.add('is-locked');
            slot.textContent = String(i + 1);
          }
          slotsContainer.appendChild(slot);
        }
      });

      // Cart items list
      cartItemsEl.innerHTML = '';
      Object.keys(state.selections).forEach(function (id) {
        var entry = state.selections[id];
        var row = document.createElement('div');
        row.className = 'bb__cart-item';
        var swatch = document.createElement('span');
        swatch.className = 'bb__cart-item-swatch';
        swatch.style.background = entry.card.dataset.productColor || 'var(--bb-card)';
        var name = document.createElement('span');
        name.className = 'bb__cart-item-name';
        name.textContent = entry.card.dataset.productTitle || '';
        var qty = document.createElement('span');
        qty.className = 'bb__cart-item-qty';
        qty.textContent = '\u00d7' + entry.qty;
        var rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'bb__cart-item-remove';
        rm.textContent = '\u2715';
        rm.addEventListener('click', function () {
          delete state.selections[id];
          render();
        });
        row.appendChild(swatch);
        row.appendChild(name);
        row.appendChild(qty);
        row.appendChild(rm);
        cartItemsEl.appendChild(row);
      });

      // Per-card stepper state
      cards.forEach(function (card) {
        var vid = card.dataset.variantId;
        var qty = state.selections[vid] ? state.selections[vid].qty : 0;
        var addBtn = card.querySelector('[data-action="add"]');
        var stepper = card.querySelector('[data-stepper]');
        var qtyEl = card.querySelector('[data-card-qty]');
        if (qty > 0) {
          addBtn.hidden = true;
          stepper.hidden = false;
          qtyEl.textContent = String(qty);
          card.classList.add('is-selected');
        } else {
          addBtn.hidden = false;
          stepper.hidden = true;
          card.classList.remove('is-selected');
          if (isFull) {
            addBtn.disabled = true;
            addBtn.textContent = 'Bundle Full';
          } else {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to bundle';
          }
        }
        // Disable increment when full
        var inc = card.querySelector('[data-action="increment"]');
        if (inc) inc.disabled = isFull;
      });

      // Totals
      var retailCents = 0;
      Object.keys(state.selections).forEach(function (id) {
        retailCents += priceCents(state.selections[id].card) * state.selections[id].qty;
      });
      var subtotalCents = isFull
        ? Math.round(retailCents * (1 - tierInfo.savings / 100))
        : retailCents;
      // For partial, just show retail; once full apply tier price
      var savingsCents = Math.max(0, retailCents - subtotalCents);

      if (retailEl) retailEl.textContent = formatMoney(retailCents);
      subtotalEls.forEach(function (el) { el.textContent = formatMoney(subtotalCents); });
      if (savingsEl) savingsEl.textContent = formatMoney(savingsCents);
      if (saveRow) saveRow.hidden = !(isFull && savingsCents > 0);

      // CTA
      ctaLabels.forEach(function (el) {
        el.textContent = isFull
          ? 'Add Bundle to Cart'
          : 'Add ' + (size - total) + ' more pack' + (size - total === 1 ? '' : 's');
      });
      ctaButtons.forEach(function (btn) { btn.disabled = !isFull; });
    }

    // ---- Add to cart ----
    function buildCartItems() {
      var bundleId = 'bundle_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
      // Defensive: tier may be missing if a merchant removed the matching block in the editor.
      var tier = state.tiers[String(state.bundleSize)];
      var tierPriceProp = tier && typeof tier.price === 'number'
        ? tier.price.toFixed(2)
        : '';
      var items = [];
      Object.keys(state.selections).forEach(function (id) {
        var entry = state.selections[id];
        var props = {
          _bundle_id: bundleId,
          _bundle_size: String(state.bundleSize)
        };
        if (tierPriceProp) props._bundle_tier_price = tierPriceProp;
        items.push({
          id: parseInt(id, 10),
          quantity: entry.qty,
          properties: props
        });
      });
      return { items: items, bundleId: bundleId };
    }

    ctaButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (totalSelected() < state.bundleSize) return;
        btn.disabled = true;
        ctaLabels.forEach(function (el) { el.textContent = 'Adding...'; });

        var payload = buildCartItems();

        // 1. Set cart attribute so discount rules / cart UI can read bundle size
        var attrFetch = fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            attributes: {
              bundle_size: String(state.bundleSize),
              bundle_id: payload.bundleId
            }
          })
        });

        // 2. Add all line items in a single request
        attrFetch
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: payload.items })
            });
          })
          .then(function (res) {
            if (!res.ok) throw new Error('cart-add-failed');
            return res.json();
          })
          .then(function () {
            // Apply tier bundleSize code, then redirect to checkout
            var discountCode = state.bundleSize >= 12 ? 'BUNDLE12PACK' : 'BUNDLE8PACK';
            window.location.href = '/discount/' + discountCode + '?redirect=/checkout';
          })
          .catch(function () {
            ctaLabels.forEach(function (el) { el.textContent = 'Something went wrong. Try again.'; });
            btn.disabled = false;
          });
      });
    });
    // ---- Drag and Drop ----
    (function () {
      var cartPanel = section.querySelector('.bb__cart');
      if (!cartPanel) return;
      cards.forEach(function (card) {
        card.setAttribute('draggable', 'true');
        card.classList.add('bb__card--draggable');
        card.addEventListener('dragstart', function (e) {
          e.dataTransfer.setData('text/plain', card.dataset.variantId);
          e.dataTransfer.effectAllowed = 'copy';
          card.classList.add('bb__card--dragging');
          cartPanel.classList.add('bb__cart--drop-target');
        });
        card.addEventListener('dragend', function () {
          card.classList.remove('bb__card--dragging');
          cartPanel.classList.remove('bb__cart--drop-target');
          cartPanel.classList.remove('bb__cart--drop-over');
        });
      });
      cartPanel.addEventListener('dragover', function (e) {
        if (totalSelected() >= state.bundleSize) return;
        e.preventDefault();
        e.dataTransfer.dropEffect = 'copy';
        cartPanel.classList.add('bb__cart--drop-over');
      });
      cartPanel.addEventListener('dragleave', function (e) {
        if (!cartPanel.contains(e.relatedTarget)) {
          cartPanel.classList.remove('bb__cart--drop-over');
        }
      });
      cartPanel.addEventListener('drop', function (e) {
        e.preventDefault();
        cartPanel.classList.remove('bb__cart--drop-over');
        var variantId = e.dataTransfer.getData('text/plain');
        var card = section.querySelector('[data-variant-id="' + variantId + '"]');
        if (card) addOne(variantId, card);
      });
    })();

    render();
  }

  function boot() {
    document.querySelectorAll('[data-bundle-builder]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when section is reloaded in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-bundle-builder]');
    if (section) init(section);
  });
})();
